import React, { useState, useEffect } from 'react'
import { ActionIcon, Box, Button, Group, NumberInput, Paper, SimpleGrid } from '@mantine/core'
import { useSelector } from 'react-redux'
import { IconTrash } from '@tabler/icons-react'

const defaultErrorQty = [
  {
    message: '',
  },
  {
    message: '',
  },
  {
    message: '',
  },
]
const defaultErrorPrice = [
  {
    message: '',
  },
  {
    message: '',
  },
  {
    message: '',
  },
]

const FormWholesalePrice = ({ detail, loading, onCloseForm, onSave }) => {
  const { prices, summary } = useSelector(state => state.product_detail)

  const [listWholesalePrices, setListWholesalePrices] = useState([])
  const [errorValidationQty, setErrorValidationQty] = useState(defaultErrorQty)
  const [errorValidationPrice, setErrorValidationPrice] = useState(defaultErrorPrice)

  const handleChange = (index, key, value) => {
    let data = JSON.parse(JSON.stringify(listWholesalePrices))
    data[index][key] = value
    setListWholesalePrices(data)
  }

  const handleAddPrice = () => {
    const data = [...listWholesalePrices, { 'min_quantity': 0, 'price': 0 }]
    setListWholesalePrices(data)
  }

  const handleRemovePrice = (index) => {
    const data = [...listWholesalePrices]
    data.splice(index, 1)
    setListWholesalePrices(data)
  }

  const checkValidation = () => {
    let isPass = true
    const _validationQty = JSON.parse(JSON.stringify(defaultErrorQty))
    const _validationPrice = JSON.parse(JSON.stringify(defaultErrorPrice))

    listWholesalePrices.forEach((dataWholeSalePrice, index) => {
      if (+dataWholeSalePrice.min_quantity <= 1) {
        _validationQty[index].message = "Minimum Quantity must be more than 1"
        isPass = false
      }
      if (+dataWholeSalePrice.price === 0) {
        _validationPrice[index].message = "Minimum Quantity can't be Empty"
        isPass = false
      }
      if (index !== 0) {
        if (+dataWholeSalePrice.min_quantity <= +listWholesalePrices[index - 1].min_quantity) {
          _validationQty[index].message = "Minimum Quantity can't be fewer than before"
          isPass = false
        }
      }
    })

    setErrorValidationQty(_validationQty)
    setErrorValidationPrice(_validationPrice)
    return isPass
  }

  const generatePayload = () => {
    const result = []
    listWholesalePrices.forEach((dataWholesale, index) => {
      const attributes = {
        min_quantity: +dataWholesale.min_quantity,
        max_quantity: index === listWholesalePrices.length - 1
          ? 0
          : +listWholesalePrices[index + 1].min_quantity - 1,
        price: +dataWholesale.price,
      }
      result.push({ attributes })
    })
    return { wholesale_prices: result }
  }

  const handleSave = () => {
    const isPass = checkValidation()
    if (isPass) {
      const payload = generatePayload()
      console.log(payload)
      onSave(payload)
    }
  }

  useEffect(() => {
    if (prices) {
      const { wholesalePrices } = prices
      setListWholesalePrices(wholesalePrices)
    }
    // eslint-disable-next-line
  }, [prices])

  const renderPrices = (listWholesalePrices) => listWholesalePrices.map((value, index) => {
    return (
      <Paper shadow="sm" p="lg" key={index} my={15} withBorder style={{ position: 'relative' }}>
        <Box style={{ position: 'absolute', right: 0, top: 0 }}>
          {
            listWholesalePrices.length > 1 &&
            <ActionIcon variant="transparent" size='lg' color='red' onClick={() => handleRemovePrice(index)}>
              <IconTrash style={{ width: '55%', height: '55%' }} stroke={1.5} />
            </ActionIcon>
          }
        </Box>
        <SimpleGrid cols={2} spacing={'md'}>
          <NumberInput
            size='xs'
            label="Min Order Quantity"
            placeholder="Input placeholder"
            value={value.min_quantity}
            suffix={` ${summary.quantityUnit}`}
            error={errorValidationQty[index].message}
            onChange={(val) => handleChange(index, 'min_quantity', val)}
          />
          <NumberInput
            size='xs'
            label={`Wholesale Price (${summary.originalCurrency})`}
            placeholder="Input placeholder"
            value={value.price}
            prefix={`${summary.originalCurrency} `}
            error={errorValidationPrice[index].message}
            onChange={(val) => handleChange(index, 'price', val)}
          />
        </SimpleGrid>
      </Paper>
    )
  })
  return (
    <Box>
      <Group justify="flex-end">
        {listWholesalePrices.length <= 2 && <Button size='xs' variant='outline' onClick={() => handleAddPrice()}>+ Add Price</Button>}
      </Group>

      {renderPrices(listWholesalePrices)}

      <Group justify="flex-end" mt={10}>
        <Button size='xs' variant='default' onClick={onCloseForm}>Cancel</Button>
        <Button loaderProps={{ type: 'dots' }} disabled={listWholesalePrices === 0} loading={loading} size='xs' onClick={() => handleSave()}>Save</Button>
      </Group>
    </Box>
  )
}

export default FormWholesalePrice